import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'projects/eCash/src/environments/environment';
import { catchError, Observable, retry, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BaseHttpService {
    apiurl = environment.apiUrl;
    constructor(private http: HttpClient) {
    }

    public get<T>(url: string, options?: object) {
        return this.http.get<T>(this.apiurl + url, options)
        .pipe(
            catchError(this.handleError)
        );
    }
    
    public post<T>(url: string, data: any, options?: object): Observable<T> {
        return this.http.post<T>(this.apiurl + url, data, options)
        .pipe(
            catchError(this.handleError)
        );
    }

    public postByAll<T>(url: string, data: T, options?: object) {
        return this.http.post<T[]>(this.apiurl + url, data, options)
        .pipe(
            retry(3),
            catchError(this.handleError)
        );
    }

    public put<T>(url: string, data: any | null, options?: object) {
        return this.http.put<T>(this.apiurl + url, data, options)
        .pipe(
            retry(3),
            catchError(this.handleError)
        );
    }

    public delete<T>(url: string, options?: object) {
        return this.http.delete<T>(this.apiurl + url, options)
        .pipe(
            retry(3),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (!environment.production) {
            console.error(`Backend returned code ${error.status}, body was: `, error.error);
        }
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}